import script from "./SubscriptionPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscriptionPage.vue?vue&type=script&setup=true&lang=js"

import "./SubscriptionPage.vue?vue&type=style&index=0&id=53bfc1e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53bfc1e2"]])

export default __exports__